document.addEventListener("DOMContentLoaded", function () {
  const scrollButtons = document.querySelectorAll('.smooth-scroll-btn');
  const targetElement = document.querySelector('.product');

  scrollButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const scrollButtons = document.querySelectorAll('.smooth-scroll-btn-on-reviews');
  const targetElement = document.querySelector('#looxReviews');
  scrollButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});
